module.exports = __webpack_public_path__ + "img/task_icon5.55639823.png";